import { FlowCreatePatientOrderConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export type CreatePatientOrderConfig = z.infer<typeof FlowCreatePatientOrderConfigSchema>;

export const CreatePatientOrderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreatePatientOrder),
  config: FlowCreatePatientOrderConfigSchema,
});

export type CreatePatientOrderBlock = z.infer<typeof CreatePatientOrderBlockSchema>;
